/**
 * Підтвердження після відгуку про замовника.
 *
 * Owner 2026-08-27: за ПЕРШУ оцінку конкретного замовника нараховуємо 1 ₴ на
 * бонусний рахунок — і кажемо про це попапом з кнопкою в розділ бонусів.
 * Повторне редагування свого ж відгуку не оплачується, тоді показуємо просте
 * «Дякую за відгук», як і раніше.
 *
 * Текст той самий, що й у боті (`bot/handlers/vacancy_callbacks.py`), щоб
 * людина бачила однакове формулювання в обох місцях.
 */
import { showAppAlert } from "@/lib/appAlert";

export type ReviewSubmitResult = {
  ok: boolean;
  review_id: number;
  rewarded?: boolean;
  reward_uah?: number;
};

export function showReviewSaved(
  res: ReviewSubmitResult | undefined,
  goToBonuses: () => void,
): void {
  if (!res?.rewarded) {
    showAppAlert("Дякую за відгук");
    return;
  }
  showAppAlert(
    "Дякуємо за оцінку — саме з таких відгуків інші бачать, з ким мають справу.",
    {
      title: `+${res.reward_uah ?? 1} ₴ на бонусний рахунок`,
      emoji: "⚡",
      buttons: [
        {
          label: "Перейти до бонусів",
          variant: "primary",
          onClick: goToBonuses,
        },
        { label: "Пізніше", variant: "ghost" },
      ],
    },
  );
}
